import { useEffect, useState } from "react";
import { Mail, Linkedin } from "lucide-react";
import { api } from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const normalizeUrl = (url) => {
  if (!url) return "";
  const u = url.trim();
  return /^https?:\/\//i.test(u) ? u : `https://${u}`;
};

export default function Team() {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    api.get("/team").then((r) => setTeam(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="team-page">
      <PageHero
        eyebrow="Bestuur 2026-2027"
        title={<>Ontmoet<br />het team.</>}
        subtitle="Een gedreven groep rechtenstudenten die ELSA Brussel vormgeeft — van academische activiteiten tot internationale samenwerkingen."
        testid="team-hero"
      />

      {/* SFEERFOTO TEAM (vorig jaar) */}
      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 pt-6 pb-16" data-testid="team-group-photo">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <Reveal className="lg:col-span-7">
            <figure className="group overflow-hidden rounded-xl">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_elsa-community/artifacts/qcl317gp_ELSA_STUDENTS_SHOOT_BRUSSELS_NOV2025_V1-00857.webp"
                alt="Het team van ELSA Brussel"
                className="w-full h-auto object-contain transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]"
              />
            </figure>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={0.1}>
            <p className="text-sm tracking-[0.25em] uppercase mb-4" style={{ color: "var(--elsa-grey)" }}>Ons team in beeld</p>
            <h2 className="font-serif text-3xl md:text-4xl leading-[1.1] text-[#0B0B0C] mb-5">Eén team, één missie.</h2>
            <p className="text-muted-foreground text-balance">
              Van de trappen van het Justitiepaleis tot de collegebanken — ELSA Brussel is een hechte groep
              rechtenstudenten die elkaar versterkt. Samen bouwen we aan academische groei, een sterk netwerk
              en onvergetelijke momenten.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {team.map((m, i) => (
            <Reveal key={m.id} delay={(i % 3) * 0.08}>
              <div className="group" data-testid={`team-card-${i}`}>
                <div className="relative overflow-hidden aspect-[4/5] bg-[#EEF1F7]">
                  {m.image_url ? (
                    <img
                      src={m.image_url}
                      alt={m.name}
                      className="h-full w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100"
                    />
                  ) : (
                    <div className="h-full w-full grid place-items-center font-serif text-6xl text-[#0A3087]/20">{m.name?.[0]}</div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A3087]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
                <div className="pt-5">
                  <p className="text-xs tracking-[0.2em] uppercase mb-1" style={{ color: "var(--elsa-blue)" }}>{m.role}</p>
                  <h3 className="font-serif text-2xl text-[#0B0B0C]">{m.name}</h3>
                  {m.bio && <p className="text-muted-foreground text-sm mt-2 text-balance">{m.bio}</p>}
                  <div className="flex gap-2 mt-3">
                    {m.email && <a href={`mailto:${m.email}`} className="h-8 w-8 grid place-items-center rounded-full border border-black/10 hover:border-[#0A3087] hover:text-[#0A3087] transition-colors"><Mail size={14} /></a>}
                    {m.linkedin && <a href={normalizeUrl(m.linkedin)} target="_blank" rel="noreferrer" className="h-8 w-8 grid place-items-center rounded-full border border-black/10 hover:border-[#0A3087] hover:text-[#0A3087] transition-colors"><Linkedin size={14} /></a>}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        {team.length === 0 && <p className="text-muted-foreground">Teamleden worden binnenkort toegevoegd.</p>}
      </section>
    </div>
  );
}
